export default __webpack_public_path__ + "static/media/introduce05.06a4cd87.png";